import type { FinalPayableRoundingResult } from "./final-payable-rounding";
import { localCartSaleFingerprint, type LocalCartDraft } from "../local-store/cart-state";
import type { LocalLoyaltyRedemption } from "../local-store/loyalty-redemption-state";

export function resolveLocalSaleFinalPayable(
  base: FinalPayableRoundingResult,
  redemption: LocalLoyaltyRedemption | null,
  cart: LocalCartDraft,
  currencyCode: string,
  now = Date.now(),
): FinalPayableRoundingResult {
  if (!redemption) return base;
  if (redemption.reservationState !== "RESERVED") throw new Error("LOYALTY_REWARD_RESERVATION_NOT_READY");
  if (redemption.validUntil && Date.parse(redemption.validUntil) <= now) throw new Error("LOYALTY_REWARD_RESERVATION_EXPIRED");
  if (!cart.selectedMember || cart.selectedMember.customerId !== redemption.customerId) {
    throw new Error("LOYALTY_REWARD_CART_CUSTOMER_MISMATCH");
  }

  const pricing = redemption.pricing;
  if (!pricing || pricing.cartFingerprint !== localCartSaleFingerprint(cart)) {
    throw new Error("LOYALTY_REWARD_QUOTE_REQUIRED");
  }
  if (pricing.currencyCode !== currencyCode) throw new Error("LOYALTY_REWARD_CURRENCY_MISMATCH");

  return {
    ...base,
    preRoundingTotal: Number((pricing.totalAmount - pricing.roundingAmount).toFixed(2)),
    roundingAmount: pricing.roundingAmount,
    totalAmount: pricing.totalAmount,
  };
}
